import { BaseModalV2 } from 'components/ui/BaseModal'
import React from 'react'
import useLocaleText from 'components/useLocaleText'
import { ModalHeader } from '../commonUI/Modal/ModalHeader'
import { ModalFooter } from '../commonUI/Modal/ModalFooter'
import { OverviewCampaignModalProps } from 'redux/actions/campaigns'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import OverviewCampaignFields from './OverviewCampaignFields'

const OverviewCampaignModal = ({ isOpen, onClose, campaign, campaignData }: OverviewCampaignModalProps) => {
  const modal_title = campaign?.title || 'Overview Campaign'
  const admin_submit_button = useLocaleText('close')
  const { isCampaignCreating } = useSelector((state: RootState) => state.campaigns)

  return (
    <BaseModalV2
      isOpen={isOpen}
      onClose={onClose}
      header={<ModalHeader title={modal_title} onClose={onClose} />}
      body={<OverviewCampaignFields campaignData={campaignData} campaign={campaign} />}
      footer={<ModalFooter isLoading={false} buttonText={admin_submit_button} onSubmit={onClose} />}
      modalContentProps={{
        w: '100%',
        maxW: { base: '90vw', md: '80vw', lg: '800px' },
        minW: '350px',
      }}
      modalBodyProps={{
        height: 'auto',
        minH: '70vh',
        maxH: { base: '80dvh', md: '70dvh' },
        opacity: isCampaignCreating ? 0.5 : 1,
        pointerEvents: isCampaignCreating ? 'none' : 'auto',
      }}
      modalHeaderProps={{
        boxShadow: 'none',
        opacity: isCampaignCreating ? 0.5 : 1,
        pointerEvents: isCampaignCreating ? 'none' : 'auto',
      }}
    />
  )
}

export default OverviewCampaignModal
